import { createContext } from 'react';
import { Schoolyear } from '@teetsh/app/src/types/schoolyear';
import { School } from '@teetsh/app/src/types/school';

interface SchoolSchoolyear {
  schoolyear: Schoolyear;
  school: School;
}

const SchoolSchoolyearContext = createContext<SchoolSchoolyear | undefined>(
  undefined,
);

export { SchoolSchoolyearContext };
